import { render } from "./MainLogPage.vue?vue&type=template&id=6fdc38b6&scoped=true"
import script from "./MainLogPage.vue?vue&type=script&lang=js"
export * from "./MainLogPage.vue?vue&type=script&lang=js"

import "./MainLogPage.vue?vue&type=style&index=0&id=6fdc38b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fdc38b6"]])

export default __exports__